import { Grid } from '@material-ui/core';
import {
  EntityApiDefinitionCard,
  EntityConsumingComponentsCard,
  EntityProvidingComponentsCard,
} from '@backstage/plugin-api-docs';
import {
  EntityAboutCard,
  EntityLayout,
  EntityLinksCard,
  EntitySwitch,
} from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';

import { EntityMarkdownCard } from '../EntityMarkdown/EntityMarkdownCard';
import { McpServerInstallCard } from '../mcp/McpServerInstallCard';
import { McpServerToolsCard } from '../mcp/McpServerToolsCard';
import { isApiEntityMcpServer } from '../mcp/isApiEntityMcpServer';
import { EntityWarningContent } from './EntityWarningContent';

export const ApiEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <EntityWarningContent />
        <Grid item md={6} xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <EntityAboutCard />
            </Grid>
            <Grid item xs={12}>
              <EntitySwitch>
                <EntitySwitch.Case if={e => isApiEntityMcpServer(e)}>
                  <McpServerInstallCard />
                </EntitySwitch.Case>
              </EntitySwitch>
            </Grid>
            <Grid item xs={12}>
              <EntityLinksCard />
            </Grid>
            <Grid item xs={12}>
              <EntityMarkdownCard />
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={6} xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <EntityCatalogGraphCard height={400} />
            </Grid>
            <Grid item xs={12}>
              <EntityProvidingComponentsCard />
            </Grid>
            <Grid item xs={12} style={{ marginTop: 12 }}>
              <EntityConsumingComponentsCard />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/definition" title="Definition" if={e => !isApiEntityMcpServer(e)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <EntityApiDefinitionCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/tools" title="Tools" if={e => isApiEntityMcpServer(e)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <McpServerToolsCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
